import type {
  UpdateApiCredentialsRequest,
  Configuration,
  CreateApiCredentialsRequest,
  ListApiCredentialsResponse,
} from '@repo/api-gw-sdk';
import {
  DeleteApiCredentialsApi,
  ListApiCredentialsApi,
  UpdateApiCredentialsApi,
  CreateApiCredentialsApi,
} from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/api-credentials';

export const apiCredentials = (
  httpClient: HttpClient,
  config: Configuration,
  isDevOrTest: boolean
) => {
  const listApiCredentialsApi = new ListApiCredentialsApi(config);
  const createApiCredentialsApi = new CreateApiCredentialsApi(config);
  const deleteApiCredentialsApi = new DeleteApiCredentialsApi(config);
  const updateApiCredentialsApi = new UpdateApiCredentialsApi(config);

  return {
    list: () =>
      httpClient.execute(
        (
          ...args: Parameters<typeof listApiCredentialsApi.listApiCredentials>
        ) =>
          listApiCredentialsApi.listApiCredentials(...args).catch((err) => {
            if (isDevOrTest) {
              return {
                apiCredentials: [],
                pagination: {
                  recordsCount: 0,
                },
              } satisfies ListApiCredentialsResponse;
            }

            throw err;
          }),
        baseUrl,
        ''
      ),
    create: (apiCredentials: CreateApiCredentialsRequest) =>
      createApiCredentialsApi.createApiCredentials(apiCredentials),
    update: (id: string, apiCredentials: UpdateApiCredentialsRequest) =>
      updateApiCredentialsApi.updateApiCredentials(id, apiCredentials),
    delete: (id: string) => deleteApiCredentialsApi.deleteApiCredentials(id),
  };
};
